import { API } from './interceptor'

export const notifyStockTakePaywallSales = ({
  venueId,
  source = 'client',
  platform = 'dashboard',
  stockTakeTitle = null,
  startDate = null,
  endDate = null,
  currentUsage = null,
}) => {
  if (!venueId) {
    return Promise.resolve()
  }

  return API.post('api2', `venue/${venueId}/stock-take-paywall-notify`, {
    body: {
      source,
      platform,
      stockTakeTitle,
      startDate,
      endDate,
      currentUsage,
    },
  }).catch(() => {
    // Fire-and-forget; paywall UX must not depend on sales notify
  })
}
